export default __webpack_public_path__ + "static/media/hero22.ec8a57af.jpg";